module.exports = __webpack_public_path__ + "img/CCarpentom64_ua.ba8fdf37.webp";